export default {
    assigned_book: 'Asignación',
    challenges: 'Desafíos',
    challenge: 'Desafíos',
    challenges_desc: 'Supera los desafíos y gana premios.',
    get_beecoins_and_xp: 'Consigue BeeCoins y XP',
    complete_the_events: 'Completa los retos',
    empty_messages: 'Sin mensajes',
    empty_notifications: 'Sin notificaciones',
    end_date: 'Fecha de término',
    get: 'Recibir',
    greet: '¡Hola',
    logout: 'Salir',
    my_books: 'Mis libros',
    books: 'Mis libros',
    articles: 'Mis artículos',
    my_articles: 'Mis artículos',
    my_profile: 'Mi perfil',
    profile: 'Mi perfil',
    my_subscriptions: 'Mis suscripciones',
    news_from_library: 'Novedades de la biblioteca',
    news_from_store: 'Novedades de tu tienda',
    no_book: 'No tiene libro asignado este mes.',
    no_book_title: 'Tu nuevo libro',
    no_book_assigned_title: 'Tu nuevo libro asignado',
    no_book_content: 'Escoge un nuevo libro desde la biblioteca y recibe recompensas por terminarlo.',
    no_book_assigned: 'Tu maestra/o pronto te asignará un nuevo libro.',
    no_super_recommended: 'No tenemos recomendaciones por el momento.',
    own_taste: 'Gusto propio',
    pages: 'Páginas',
    pending_readings: 'Más libros',
    pending_readings_desc: 'Anímate y finaliza tus libros.',
    ranking: 'Ranking',
    ranking_subtitle: 'Mira tu posición',
    ranking_desc: 'Conoce los mejores puntajes.',
    reminder: 'Recordatorio',
    rewards: 'Recompensas',
    start_reading: 'Comenzar la lectura',
    store: 'Tienda',
    library: 'Biblioteca',
    store_desc: 'Compra con tus BeeCoins.',
    super_recommended: '¡Súper recomendado!',
    do_click: 'Debes hacer clic para ver el mensaje',
    no_message: 'Sin mensajes para mostrar',
    notification_text_1:
        'Recuerda continuar con tu libro asignado antes de que acabe el tiempo. Si deseas reanudar la lectura haz click aquí.',
    notification_text_2:
        'Estás a punto de vivir una experiencia de lectura única. Disfruta de las recomendaciones que tenemos para ti. Accede de inmediato y disfruta tus lecturas sugeridas.',
    notification_text_3:
        'Todo lo que necesitas para decorar tu plataforma a un solo clic. Accede a increíbles herramientas adicionales.',
    your_progress: 'Tu avance',
    continue_with_your_reading: 'Continúa con tu lectura',
    assigned_books_and_by_own_taste: 'Libros asignados y por gusto propio',
    continuous_reading: 'Continuar lectura',
    position: 'Posición',
    player: 'Jugador/a',
    accumulated_xp:'XP Acumulado',
    your_position: 'Tu posición',
    number_of_days: '{count} día | {count} días',
    starts_in: 'Comienza en ',
    congrats: '¡Felicidades!',
    reward_earned: 'Ya has recogido todas tus recompensas. ¿Tienes ganas de más? ¡Sigue devorando libros y desafíos para que acumules más logros!',
    challenge_hasnt_been_completed: 'No ha completado el reto',
    reward_already_awarded: 'Has recogido tus merecidas recompensas. ¿Cuál será tu próxima aventura?',
    items_to_items: '{actual} de {toComplete}',
    assignedBook: {
        diffDays: {
            createdAgo: 'Creado hace',
            createdInLessThan: 'Creado hace menos de',
            days: 'días',
            day: 'día',
            daysAgo: 'días',
            dayAgo: 'día',
            hours: 'horas',
            hour: 'hora',
            inLess: 'En menos de',
            lessThan: 'Hace menos de',
            startsIn: 'Empieza en',
            startsInLessThan: 'Empieza en menos de',
            remain: 'Quedan',
            remainLess: 'Quedan menos de',
            finished: 'Terminó hace',
            finishedInLess: 'Terminó hace menos de',
            finishAt: 'Termina el',
        },
    }
}
